// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.EditNodeDetails__nodeOptions___clDjd {
    width: 100%;
}

.EditNodeDetails__title___lYJst {
    margin: 8px 0 2px;
    padding: 7px 10px;
    border-top: 1px solid rgba(173, 139, 62, 0.16);
    background: linear-gradient(
        90deg,
        transparent,
        rgba(0, 0, 0, 0.42) 24%,
        rgba(0, 0, 0, 0.64) 50%,
        rgba(0, 0, 0, 0.42) 76%,
        transparent
    );
    color: rgba(235, 230, 211, 0.5);
    font-family: "IM Fell French Canon SC";
    text-align: center;
}

.EditNodeDetails__content___x6uDv {
    box-sizing: border-box;
    width: calc(100% - 24px);
    max-width: 720px;
    margin: 2px auto 4px;
    padding: 16px;
    border: 1px solid rgba(173, 139, 62, 0.45);
    background:
        linear-gradient(135deg, rgba(151, 116, 39, 0.08), transparent 32%),
        rgba(4, 5, 5, 0.72);
    box-shadow:
        inset 0 0 18px rgba(0, 0, 0, 0.55),
        0 6px 20px rgba(0, 0, 0, 0.25);
    text-align: left;
}

.EditNodeDetails__fields___CNfQH {
    display: flex;
    flex-direction: column;
    gap: 14px;
}

.EditNodeDetails__field___skkCI {
    min-width: 0;
}

.EditNodeDetails__fieldLabel___ZqxQI {
    display: block;
    margin: 0 0 5px 2px;
    color: rgba(210, 205, 190, 0.58);
    font-size: 10px;
    letter-spacing: 0.09em;
    line-height: 1;
    text-transform: uppercase;
}

.EditNodeDetails__field___skkCI > span {
    display: block;
    padding: 0;
    margin: 0;
}

.EditNodeDetails__field___skkCI input {
    box-sizing: border-box;
    width: 100% !important;
    max-width: none !important;
    height: 34px;
    margin: 0;
    padding: 6px 8px;
    border: 1px solid rgba(173, 139, 62, 0.2);
    border-radius: 2px;
    background: rgba(0, 0, 0, 0.36);
    color: rgba(235, 230, 211, 0.86);
    font-family: monospace;
    font-size: 14px !important;
    font-weight: normal !important;
    text-align: left;
}

.EditNodeDetails__shortField___aghR7 {
    width: 120px;
}

.EditNodeDetails__field___skkCI input:focus {
    border-color: rgba(222, 174, 70, 0.6);
    box-shadow: 0 0 7px rgba(222, 174, 70, 0.24);
}

.EditNodeDetails__action___nmcSw {
    margin: 0;
    padding: 6px 9px;
    border: 1px solid rgba(173, 139, 62, 0.28);
    border-radius: 2px;
    background: rgba(0, 0, 0, 0.48);
    color: rgba(235, 230, 211, 0.9);
    font-size: 0.72em;
    letter-spacing: 0.025em;
}

.EditNodeDetails__action___nmcSw:hover {
    border-color: rgba(222, 174, 70, 0.62);
    background: rgba(116, 83, 25, 0.24);
    color: #fff5ce;
}

.EditNodeDetails__nodeIdRow___AKpwB {
    display: grid;
    grid-template-columns: 1fr auto 1fr;
    align-items: center;
    margin-bottom: 14px;
    padding-bottom: 10px;
    border-bottom: 1px solid rgba(173, 139, 62, 0.25);
}

.EditNodeDetails__nodeIdIdentity___k3257 {
    display: inline-flex;
    grid-column: 2;
    gap: 10px;
    align-items: center;
}

.EditNodeDetails__footer___IiAyc {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 14px;
    padding-top: 10px;
    border-top: 1px solid rgba(173, 139, 62, 0.25);
}

.EditNodeDetails__nodeId___cVEFr {
    color: #d9bf72;
    font-family: monospace;
    font-size: 22px;
    line-height: 1;
    text-shadow: 0 0 7px rgba(222, 174, 70, 0.25);
}

.EditNodeDetails__nodeIdLabel___FAWW6 {
    color: rgba(210, 205, 190, 0.5);
    font-size: 10px;
    letter-spacing: 0.09em;
    text-transform: uppercase;
}

.EditNodeDetails__copyAction___Wy8rs {
    grid-column: 3;
    justify-self: end;
    flex: none;
    padding: 4px 7px;
    opacity: 0.4;
    transition: opacity 140ms ease;
}

.EditNodeDetails__copyAction___Wy8rs:hover,
.EditNodeDetails__copyAction___Wy8rs:focus-within {
    opacity: 1;
}

@media (max-width: 640px) {
    .EditNodeDetails__content___x6uDv {
        width: calc(100% - 12px);
        padding: 12px;
    }

    .EditNodeDetails__shortField___aghR7 {
        width: 100%;
    }
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"nodeOptions": `EditNodeDetails__nodeOptions___clDjd`,
	"title": `EditNodeDetails__title___lYJst`,
	"content": `EditNodeDetails__content___x6uDv`,
	"fields": `EditNodeDetails__fields___CNfQH`,
	"field": `EditNodeDetails__field___skkCI`,
	"fieldLabel": `EditNodeDetails__fieldLabel___ZqxQI`,
	"shortField": `EditNodeDetails__shortField___aghR7`,
	"action": `EditNodeDetails__action___nmcSw`,
	"nodeIdRow": `EditNodeDetails__nodeIdRow___AKpwB`,
	"nodeIdIdentity": `EditNodeDetails__nodeIdIdentity___k3257`,
	"footer": `EditNodeDetails__footer___IiAyc`,
	"nodeId": `EditNodeDetails__nodeId___cVEFr`,
	"nodeIdLabel": `EditNodeDetails__nodeIdLabel___FAWW6`,
	"copyAction": `EditNodeDetails__copyAction___Wy8rs`
};
module.exports = ___CSS_LOADER_EXPORT___;
